import React from "react";
import { TYPO, COLORS, RADIUS } from "theme/tokens";

// ──────────────────────────────────────────────────────────────────────────
// MAS 設計系統共用元件：Tabs（切換頁籤）
//   對齊 design guideline「Tabs」兩款：
//     variant="pill"      → Style1 分段切換（灰底群組，選中=白底+陰影+黑字）
//     variant="underline" → Style2 文字 + 橘色底線（選中=橘字+橘底線）
//   全部顏色/字體/圓角/陰影引用 theme/tokens（單一來源）。
//
//   用法：
//     <Tabs
//       variant="pill"
//       value={billingPeriod}
//       onChange={(v) => setBillingPeriod(v)}
//       tabs={[{ value: "monthly", label: "月繳" }, { value: "yearly", label: "年繳" }]}
//     />
// ──────────────────────────────────────────────────────────────────────────
export default function Tabs({
  tabs = [],
  value,
  onChange,
  variant = "pill",
  style,
  ...rest
}) {
  const pill = variant === "pill";

  if (pill) {
    // 比照 MAS Coin（儲值方案/使用紀錄）：一個灰色容器，內含分段
    //   容器=灰底 #F6F6F6 radius12 padding6；選中=白底+淡陰影、未選=透明（融入容器灰）
    return (
      <div
        style={{
          display: "inline-flex",
          alignItems: "stretch",
          gap: 4,
          padding: 6,
          borderRadius: RADIUS.l, // 12 外框
          background: COLORS.grayLightest, // #F6F6F6 容器
          ...style,
        }}
        {...rest}
      >
        {tabs.map((t) => {
          const active = t.value === value;
          return (
            <button
              key={t.value}
              type="button"
              onClick={() => onChange && onChange(t.value)}
              style={{
                ...TYPO.headingM, // Tab = Heading-M（design guideline）
                minWidth: 160,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 10,
                padding: "8px 24px",
                borderRadius: RADIUS.m, // 8 內框
                border: "none",
                cursor: "pointer",
                whiteSpace: "nowrap",
                transition: "background 0.15s, color 0.15s, box-shadow 0.15s",
                background: active ? COLORS.white : "transparent", // 選中白 / 未選透明（露容器灰）
                color: active ? COLORS.black : COLORS.grayDark,
                boxShadow: active ? "0 0 6px 0 rgba(0, 0, 0, 0.06)" : "none",
              }}
            >
              {t.label}
            </button>
          );
        })}
      </div>
    );
  }

  // underline（Style2）
  return (
    <div style={{ display: "inline-flex", alignItems: "center", gap: 24, ...style }} {...rest}>
      {tabs.map((t) => {
        const active = t.value === value;
        return (
          <button
            key={t.value}
            type="button"
            onClick={() => onChange && onChange(t.value)}
            style={{
              ...TYPO.headingM,
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "8px 2px",
              background: "none",
              border: "none",
              borderBottom: `2px solid ${active ? COLORS.main : "transparent"}`,
              cursor: "pointer",
              whiteSpace: "nowrap",
              transition: "color 0.15s, border-color 0.15s",
              color: active ? COLORS.main : COLORS.black,
            }}
          >
            {t.label}
          </button>
        );
      })}
    </div>
  );
}
